<div
  tabindex="{{ index }}"
  class="a-chip"
  [class.-image]="imageSrc"
  [class.-btnClose]="removable"
  [class.-icon]="icon"
  [class.a-chip--fixed]="fixed"
  [class.-selected]="selected"
  [class.-disabled]="disabled"
  [attr.aria-labelledby]="id"
  role="button"
>
  <div *ngIf="imageSrc" class="fixed-width-image-label-group">
    <ng-container *ngTemplateOutlet="chipTemplate"></ng-container>
  </div>

  <ng-container *ngIf="!imageSrc">
    <ng-container *ngTemplateOutlet="chipTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #chipTemplate>
  <bosch-ui-icon *ngIf="icon" [name]="icon"></bosch-ui-icon>
  <img *ngIf="imageSrc" class="a-chip__image" alt="ChipImage" width="24" height="24" src="{{ imageSrc }}" />
  <span [id]="id" class="a-chip__label">
    <ng-content></ng-content>
  </span>
  <bosch-ui-icon *ngIf="removable" [name]="closeIcon" (click)="remove()"></bosch-ui-icon>
</ng-template>
